import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import {
	InstantSelfExclusionRequest,
	SelfExclusionRequest,
	StartSessionLimitTimerPayload,
} from "./responsible-gaming.model";

export const ACTION_PREFIX = "[Responsible Gaming]";
export const RESPONSIBLE_GAMING_ACTION_TYPE = {
	updateSelfExclusionPeriod: `${ACTION_PREFIX} Update Self Exclusion Period`,
	updateSelfExclusionPeriodSuccess: `${ACTION_PREFIX} Update Self Exclusion Period Success`,
	updateSelfExclusionPeriodFail: `${ACTION_PREFIX} Update Self Exclusion Period Fail`,

	updateInstantSelfExclusionPeriod: `${ACTION_PREFIX} Update Instant Self Exclusion Period`,
	updateInstantSelfExclusionPeriodSuccess: `${ACTION_PREFIX} Update Instant Self Exclusion Period Success`,
	updateInstantSelfExclusionPeriodFail: `${ACTION_PREFIX} Update Instant Self Exclusion Period Fail`,

	updateCoolOffPeriod: `${ACTION_PREFIX} Update Cool Off Period`,
	updateCoolOffPeriodSuccess: `${ACTION_PREFIX} Update Cool Off Period Success`,
	updateCoolOffPeriodFail: `${ACTION_PREFIX} Update Cool Off Period Fail`,

	sessionLimitExpired: `${ACTION_PREFIX} Session Time Limit Expired ${SYNC_SUFFIX}`,
	stopSessionLimitCheck: `${ACTION_PREFIX} Stop Session Time Limit Check ${SYNC_SUFFIX}`,
	startSessionLimitTimer: `${ACTION_PREFIX} Start Session Time Limit Timer ${SYNC_SUFFIX}`,
	getSessionLimitCheckPeriodFail: `${ACTION_PREFIX} Get Session Time Limit Check Period Fail ${SYNC_SUFFIX}`,
	checkSessionLimit: `${ACTION_PREFIX} Check Session Time Limit ${SYNC_SUFFIX}`,
	openSessionLimitAlert: `${ACTION_PREFIX} Open Session Time Limit Alert ${SYNC_SUFFIX}`,
	closeSessionLimitAlert: `${ACTION_PREFIX} Close Session Time Limit Alert ${SYNC_SUFFIX}`,
};

/**
 * @deprecated [fabric-deprecated] - Use ResponsibleGamingService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class ResponsibleGamingAction {
	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateSelfExclusionPeriod instead
	 */
	updateSelfExclusionPeriod(payload: SelfExclusionRequest): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateSelfExclusionPeriod,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateSelfExclusionPeriod instead
	 */
	updateSelfExclusionPeriodSuccess(): Action {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateSelfExclusionPeriodSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateSelfExclusionPeriod instead
	 */
	updateSelfExclusionPeriodFail(payload: AppError): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateSelfExclusionPeriodFail,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateInstantSelfExclusionPeriod instead
	 */
	updateInstantSelfExclusionPeriod(payload: InstantSelfExclusionRequest): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateInstantSelfExclusionPeriod,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateInstantSelfExclusionPeriod instead
	 */
	updateInstantSelfExclusionPeriodSuccess(): Action {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateInstantSelfExclusionPeriodSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateInstantSelfExclusionPeriod instead
	 */
	updateInstantSelfExclusionPeriodFail(payload: AppError): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateInstantSelfExclusionPeriodFail,
			payload,
		};
	}

	sessionLimitExpired(currentSessionDuration: number): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.sessionLimitExpired,
			payload: currentSessionDuration,
		};
	}

	startSessionLimitTimer(payload: StartSessionLimitTimerPayload): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.startSessionLimitTimer,
			payload,
		};
	}

	stopSessionLimitCheck(): Action {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.stopSessionLimitCheck,
		};
	}

	getSessionLimitCheckPeriodFail(error: AppError): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.getSessionLimitCheckPeriodFail,
			payload: error,
		};
	}

	checkSessionLimit(newSessionDuration: number): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.checkSessionLimit,
			payload: newSessionDuration,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateCoolOffPeriod instead
	 */
	updateCoolOffPeriod(payload: SelfExclusionRequest): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateCoolOffPeriod,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateCoolOffPeriod instead
	 */
	updateCoolOffPeriodSuccess(): Action {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateCoolOffPeriodSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateCoolOffPeriod instead
	 */
	updateCoolOffPeriodFail(payload: AppError): ActionWithPayload {
		return {
			type: RESPONSIBLE_GAMING_ACTION_TYPE.updateCoolOffPeriodFail,
			payload,
		};
	}
}
